"use client";

import React from "react";
var __jsx = React.createElement;
import { useErrorPage } from "@lib/context/shared/errors-context";
import errorImagesStoryblokService from "@lib/storyblok/services/financial-entity-services/error-images-service";
import MusclePlatformLayout from "@modules/layout";
import ImageRender from "@modules/layout/components/shared/image-render";
import { MuscleButton } from "@modules/shared/components/buttons";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
export default function NotFound() {
  const t = useTranslations();
  const {
    closeErrorPage
  } = useErrorPage();
  const {
    0: image,
    1: setImage
  } = useState("");
  const title = t("Shared.Errors.PAGE_ERRORS.404.TITLE");
  const message = t("Shared.Errors.PAGE_ERRORS.404.MESSAGE");
  useEffect(() => {
    const fetchImage = async () => {
      const image = await errorImagesStoryblokService.getErrorImage("404");
      setImage(image);
    };
    fetchImage();
  }, []);
  return __jsx(MusclePlatformLayout, {
    headerProps: {
      hideContent: true
    },
    showCustomerSupport: false
  }, __jsx("div", {
    className: "p-16 flex flex-col items-center gap-2"
  }, __jsx(ImageRender, {
    useImage: false,
    src: image,
    alt: title,
    className: "w-96 h-96"
  }), __jsx("p", {
    className: "text-2xl font-bold text-primary-main text-center"
  }, title), __jsx("p", {
    className: "text-base font-thin text-black text-center"
  }, message), __jsx(MuscleButton, {
    text: t("Shared.Errors.RETURN_TO_HOME"),
    onClick: () => {
      closeErrorPage();
    }
  })));
}